import React from "react";
import useQueryParams from "../../hooks/useQueryParams";

export const OrderStatusFilter = () => {
  const { addOrUpdateParams, updateAndRemoveParams, params } = useQueryParams();
  const statusValue = params.status || "";

  const changeStatus = (status) => {
    if (!status) {
      updateAndRemoveParams({ page: 1 }, ["status"]);
    } else {
      addOrUpdateParams({ status, page: 1 });
    }
  };

  return (
    <div className="orders-filter-type ">
      <label htmlFor="filter-state">Type</label>
      <div className="flex-container" style={{ justifyContent: "space-between" }}>
        <button
          className={`button button--blue funeral-home-type ${!statusValue && "button--blue-active"}`}
          onClick={() => changeStatus("")}
        >
          All
        </button>
        <button
          className={`button button--red funeral-home-type ${statusValue === "new" && "button--red-active"}`}
          onClick={() => changeStatus("new")}
        >
          New
        </button>
        <button
          className={`button button--blue funeral-home-type ${statusValue === "processing" && "button--blue-active"}`}
          onClick={() => changeStatus("processing")}
        >
          In-progress
        </button>
        <button
          className={`button button--black funeral-home-type ${statusValue === "approved" && "button--black-active"}`}
          onClick={() => changeStatus("approved")}
        >
          Approved
        </button>
        <button
          className={`button button--green funeral-home-type ${statusValue === "completed" && "button--green-active"}`}
          onClick={() => changeStatus("completed")}
        >
          Completed
        </button>
        <button
          className={`button button--red funeral-home-type ${statusValue === "cancelled" && "button--red-active"}`}
          onClick={() => changeStatus("cancelled")}
        >
          Cancelled
        </button>
      </div>
    </div>
  );
};

export default OrderStatusFilter;
